import {Tooltip} from 'antd';
import React from 'react';
import {useTranslation} from 'react-i18next';

interface TranslatedTextProps {
  translationKey: string;
  tooltip?: string;
}

const TranslatedText: React.FC<TranslatedTextProps> = ({
  translationKey,
  tooltip = ''
}) => {
  const {t} = useTranslation();

  return (
    <Tooltip title={tooltip}>
      <div>{t(`${translationKey}`)}</div>
    </Tooltip>
  );
};

export default TranslatedText;
